/* eslint-disable no-alert */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import moment from 'moment';

import { del, post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

function Bins(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const { t } = props;

  const [signal, setSignal] = useState(0);

  const deleteBin = async (bin) => {
    try {
      await del(`/api/warehouse/putaway/bin/${bin.id}`);

      toastr.success(t('Bin deleted successfully'));
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, t('Could not delete bin.'));
    }
  };

  const generateRoute = async (bin) => {
    try {
      await post('/api/warehouse/putaway/route/generate', { bins: [bin.symbol], strategy: 'default' });

      toastr.success(t('Route generated successfully'));
    } catch (error) {
      toastr.error(error.message, t('Could not generate route.'));
    }
  };

  useEffect(() => {
    setSignal(0);
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">
                  <span className="mdi mdi-basket-fill fs-5" />
                  {' '}
                  {t('Put-Away Bins')}
                </CardTitle>

                <Can i="see" this="putaway">
                  <BaseGrid
                    url="/api/warehouse/putaway/bins"
                    shouldUpdate={signal}
                    hasSearch
                    config={
                      {
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                          },
                          symbol: {
                            badges: {
                              split: ',',
                              class: 'bg-info fs-5',
                            },
                            label: t('Symbol'),
                          },
                          items: {
                            label: t('Items'),
                            format: (x) => x.length,
                          },
                          created_by: {
                            label: t('Created By'),
                          },
                          created_at: {
                            label: 'Created',
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.REACT_APP_LOCAL_TZ,
                            },
                            sort: true,
                          },
                          actions: {
                            label: 'Actions',
                            actions: [
                              {
                                key: 'generate_route',
                                icon: 'mdi mdi-reload',
                                class: 'btn btn-sm btn-soft-info text-dark',
                                alt: 'Generate Route',
                                click: generateRoute,
                              },
                              {
                                key: 'remove_bin',
                                icon: 'mdi mdi-close-thick',
                                class: 'btn btn-sm btn-soft-danger text-dark',
                                alt: 'Delete Bin',
                                click: deleteBin,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                    }
                  />
                </Can>

                <Can not i="see" this="putaway"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Bins.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Bins));
